<template>
    <div class="generator__panel">
        <div class="panel-animation">
            <div class="panel-content dimensions__wrapper">
                <autocomplete :items="autoCompleteDevices"
                              @deviceSelected="onAutocompleteSelectDevice">
                </autocomplete>

                <div class="dimensions">
                    <div class="dimension dimension--width">
                        <input type="number"
                               min="320"
                               max="2560"
                               id="wallpaper-width"
                               v-model="wallpaper.width"
                               @keyup.enter="onWidthChange">
                        <span>W</span>
                    </div>

                    <div class="dimension dimension--height">
                        <input type="number"
                               min="320"
                               max="2560"
                               id="wallpaper-height"
                               v-model="wallpaper.height"
                               @keyup.enter="onHeightChange"/>
                        <span>H</span>
                    </div>
                </div>
            </div>

            <div v-bar class="panel-content devices">
                <div class="panel-content__scroll">
                    <template v-for="(groupDevices, key) in devices">

                        <h2>{{ key | capitalize }}</h2>
                        <ul>
                            <app-device v-for="(device, index) in groupDevices"
                                        :key="'device-' + index"
                                        :activeDevice="activeDevice"
                                        :device="device"
                                        @deviceSelected="onDeviceSelect"
                            ></app-device>
                        </ul>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // Components
    import AutoComplete from '../helpers/AutoComplete';
    import Device from '../panels/Device';

    // Data
    import AutocompleteDevices from '../../data/devices_autocomplete';
    import Devices from '../../data/devices';

    export default {
        data() {
            return {
                activeDevice: null,
                autoCompleteDevices: AutocompleteDevices,
                devices: Devices,
                dimensionUpdate: false,
            }
        },
        props: ['wallpaper'],
        components: {
            autocomplete: AutoComplete,
            appDevice: Device
        },
        methods: {
            onAutocompleteSelectDevice(device) {
                if (!this.dimensionUpdate) {
                    this.dimensionUpdate = true;
                    this.wallpaper.width = device.width;
                    this.wallpaper.height = device.height;
                    this.wallpaper.device = null;
                    this.activeDevice = null;
                    this.eventHub.$emit('deviceDimensionsChanged');
                }
            },
            onHeightChange() {
                if (!this.dimensionUpdate) {
                    this.dimensionUpdate = true;
                    this.wallpaper.height = event.target.value;
                    this.wallpaper.device = null;
                    this.activeDevice = null;
                    this.eventHub.$emit('resetAutocomplete');
                    this.eventHub.$emit('deviceDimensionsChanged');
                }
            },
            onWidthChange() {
                if (!this.dimensionUpdate) {
                    this.dimensionUpdate = true;
                    this.wallpaper.width = event.target.value;
                    this.wallpaper.device = null;
                    this.activeDevice = null;
                    this.eventHub.$emit('resetAutocomplete');
                    this.eventHub.$emit('deviceDimensionsChanged');
                }
            },
            onDeviceSelect(device) {
                if (!this.dimensionUpdate) {
                    this.dimensionUpdate = true;
                    this.activeDevice = device;
                    this.wallpaper.width = device.width;
                    this.wallpaper.height = device.height;
                    this.wallpaper.device = device;
                    this.eventHub.$emit('resetAutocomplete');
                    this.eventHub.$emit('deviceDimensionsChanged');
                    this.eventHub.$emit('deviceSelected');
                }
            },
        }, mounted() {
            this.activeDevice = this.devices.smartphones[0];

            this.eventHub.$on('deviceDimensionChangeFinished', data => {
                this.dimensionUpdate = false;
            });
        }
    }
</script>

<style lang="scss" scoped>
    .devices {
        height: calc(100vh - 300px);
        margin-top: 10px;

        @media(min-width: 1024px) {
            height: calc(100vh - 340px)
        }
    }

    .dimensions {
        display: flex;
        margin-top: 12px;

        @media (min-width: 1024px) {
            margin-top: 0;
            width: calc(50% - 11px);
        }

        &__wrapper {
            @media (min-width: 1024px) {
                display: flex;
            }
        }
    }

    .dimension {
        position: relative;
        width: calc(50% - 6px);

        &--width {
            margin-right: 12px;

            @media (min-width: 1024px) {
                margin-right: -1px;

                input {
                    border-bottom-right-radius: 0;
                    border-top-right-radius: 0;
                }
            }
        }

        &--height {
            @media (min-width: 1024px) {
                input {
                    border-bottom-left-radius: 0;
                    border-top-left-radius: 0;
                }
            }
        }

        &:hover {
            span {
                opacity: 1;
            }
        }

        @media (min-width: 1024px) {
            width: 137px;

        }

        input {
            text-align: right;
        }

        span {
            display: inline-block;
            font-family: PxGroteskRegular;
            font-size: 14px;
            left: 12px;
            opacity: 0.4;
            position: absolute;
            top: 12px;
            transition: all .2s linear;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/panels/Devices.vue